import { useMemo } from 'react'

import { usePostHog } from '@posthog/react'

/** Surface that opened the announcement — sent with the `opened` event. */
export type BetaAnnouncementSource = 'sidebar'

const EVENTS = {
	opened: 'beta_announcement_opened',
	acknowledged: 'beta_announcement_acknowledged',
} as const

export type BetaAnnouncementTracker = {
	trackOpened: (payload: { source: BetaAnnouncementSource }) => void
	trackAcknowledged: () => void
}

/**
 * Typed PostHog wrapper for the beta announcement. Mirrors `useAIPostHog` so
 * event names live in one place. Memoized for the lifetime of the PostHog
 * client, so the returned methods are safe to pass to handlers.
 */
export function useBetaAnnouncementPostHog(): BetaAnnouncementTracker {
	const posthog = usePostHog()

	return useMemo<BetaAnnouncementTracker>(
		() => ({
			trackOpened: (payload) => {
				posthog.capture(EVENTS.opened, payload)
			},
			trackAcknowledged: () => {
				posthog.capture(EVENTS.acknowledged)
			},
		}),
		[posthog],
	)
}
